'use client';

import { createContext, useContext } from 'react';
import { FunctionHelpers } from '@headless-workspace/utils';

export type searchStateContextType = {
    isSearchOpen: boolean;
    searchInput: string;
};

export type searchActionContextType = {
    onSearch: (search: string) => void;
    handleOpen: () => void;
    handleClose: () => void;
    onClearSearches: () => void;
    onSearchInputChange: (input: string) => void;
};

const searchStateContextInitialState: searchStateContextType = {
    isSearchOpen: false,
    searchInput: '',
};

const searchActionContextInitialState: searchActionContextType = {
    onSearch: FunctionHelpers.emptyFn,
    handleOpen: FunctionHelpers.emptyFn,
    handleClose: FunctionHelpers.emptyFn,
    onClearSearches: FunctionHelpers.emptyFn,
    onSearchInputChange: FunctionHelpers.emptyFn,
};

export const SearchStateContext = createContext<searchStateContextType>(searchStateContextInitialState);
export const SearchActionContext = createContext<searchActionContextType>(searchActionContextInitialState);

export const useSearchStateContext = () => useContext(SearchStateContext);
export const useSearchActionContext = () => useContext(SearchActionContext);
